<template>
    <div class="action-documents-table-wrapper">
        <rea-loader :loading="loading"></rea-loader>
        <table class="action-documents-table table mt-4">
            <tr v-if="!hasActionDocumentChecks">
                <td colspan="4">{{ uLang('app.empty_table') }}</td>
            </tr>
            <tr class="table-heading" v-if="actionDocumentChecks.length > 0">
                <th class="w10">{{ uLang('app.rapport') }}</th>
                <th class="w10">{{ uLang('app.submitted_at_2') }}</th>
            </tr>
            <tr v-for="actionDocumentCheck in actionDocumentChecks">
                <td>
                    <router-link
                        :to="actionDocumentLink(actionDocumentCheck)"
                        v-text="actionDocumentCheck.title"
                        target="_blank"
                    />
                </td>
                <td>{{ actionDocumentCheck.created_at | date }}</td>
            </tr>
        </table>
    </div>
</template>
<script>
import {ReaLoader} from '~/components/helpers'

export default {
    name: 'InspectableActionDocuments',

    components: {
        ReaLoader,
    },

    props: {
        entityId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            actionDocumentChecks: {},
            loading: true,
        }
    },
    async created() {
        const { data } = await window.axios.get(route("relation.get-all-action-documents", { relationId: this.entityId }));
        this.actionDocumentChecks = data;
        this.loading = false;
    },
    computed: {
        hasActionDocumentChecks() {
            return !_.isEmpty(this.actionDocumentChecks)
        },
    },
    methods: {
        actionDocumentLink(actionDocumentCheck) {
            return {
                name: 'admin.relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.update',
                params: {
                    'relationId': actionDocumentCheck.relation_id,
                    'trajectoryEnrolmentId': actionDocumentCheck.trajectory_enrolment_id,
                    'milestoneProgressId': actionDocumentCheck.milestone_progress_id,
                    'actionProgressId': actionDocumentCheck.action_progress_id,
                }
            }
        },
    },
}
</script>
<style lang="scss">
    .action-documents-table-wrapper {
        margin:10px;
    }
    table.action-documents-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .table-heading {
        width: 100%;
    }
</style>
